const getUserRole = (userAccess) => {
  const { superAdmin, dashboardAccess, manageUsers, manageEquipmentDeactivation } = userAccess;

  if (superAdmin) return 'Super Admin';
  if (dashboardAccess && manageUsers && manageEquipmentDeactivation) return 'Administrator';
  if (dashboardAccess && manageUsers) return 'Manager';
  if (dashboardAccess) return 'Editor';

  return 'Viewer';
};

export const getUserAccessAndRole = (permissions) => {
  if (!permissions) {
    return {
      userAccess: {
        showChartLink: false,
        manageUsers: false,
        manageSensorData: false,
        manageData: false,
        manageEquipmentDeactivation: false,
        appAccess: false,
      },
      userRole: 'Viewer',
    };
  }

  let userAccess = {};

  userAccess.showChartLink =
    permissions['superAdmin'] || (permissions['viewSensorData'] && permissions['showFullServiceEquipments']);

  userAccess.manageUsers = permissions['superAdmin'] || permissions['manageUsers'];

  userAccess.manageSensorData = permissions['superAdmin'] || permissions['viewSensorData'];

  userAccess.manageData =
    permissions['superAdmin'] ||
    (permissions['readonlyAccess'] || permissions['viewOnlyAccess'] ? false : true);

  userAccess.manageEquipmentDeactivation =
    permissions['superAdmin'] || permissions['manageEquipmentDeactivation'];

  userAccess.manageGpsTracking = permissions['superAdmin'] || permissions['manageGpsTracking'];

  userAccess.manageHeatMapAccess = permissions['superAdmin'] || permissions['manageHeatMapAccess'];

  userAccess.appAccess =
    permissions['superAdmin'] ||
    permissions['dashboardAccess'] ||
    permissions['readonlyAccess'] ||
    permissions['viewOnlyAccess'];

  return { userAccess, userRole: getUserRole(permissions) };
};
